import { OwnerView } from '@lemoncloud/codes-goods-api';
import { create } from 'zustand';

export interface OwnerState {
    owner: OwnerView | null;
}

export interface OwnerStore extends OwnerState {
    setOwner: (owner: OwnerView) => void;
}

const initialState: Pick<OwnerStore, keyof OwnerState> = {
    owner: null,
};

export const useOwnerStore = create<OwnerStore>()(set => ({
    ...initialState,
    setOwner: (owner: OwnerView) => set({ owner }),
}));
